module.exports = __webpack_public_path__ + "static/media/java.bfa2a8d2.png";